import React, { useState } from 'react';

import type { ChatHistoryItem } from '../../api/chat-api';

import { ChatHistoryRename } from './ChatHistoryRename';
import { ChatHistoryRow } from './ChatHistoryRow';

export type ChatHistoryEntryProps = {
  chat: ChatHistoryItem;
  hideChat: ({ chatId }: { chatId: ChatHistoryItem['id'] }) => Promise<boolean>;
  unhideChat: ({
    chatId,
  }: {
    chatId: ChatHistoryItem['id'];
  }) => Promise<boolean>;
  isActive: boolean;
  isRenaming: boolean;
  renameChat: ({
    chatId,
    name,
  }: {
    chatId: ChatHistoryItem['id'];
    name: string;
  }) => Promise<boolean>;
  setActiveChatId: ({
    chatId,
    isFull,
  }: {
    chatId: string | null;
    isFull?: boolean;
  }) => void;
  /** Renaming is the list's to hold: only one row is ever in it. */
  setRenaming: (renaming: boolean) => void;
};

export const ChatHistoryEntry = ({
  chat,
  hideChat,
  isActive,
  isRenaming,
  renameChat,
  setActiveChatId,
  setRenaming,
  unhideChat,
}: ChatHistoryEntryProps) => {
  /*
    This row's own, unlike renaming: hiding is independent per row and several can be in flight at
    once, so the list has nothing to arbitrate.
  */
  const [isMoving, setIsMoving] = useState(false);

  if (isRenaming) {
    return (
      <ChatHistoryRename
        chat={chat}
        renameChat={renameChat}
        onClose={() => {
          setRenaming(false);
        }}
      />
    );
  }

  return (
    <ChatHistoryRow
      chat={chat}
      hide={async () => {
        setIsMoving(true);

        await hideChat({ chatId: chat.id });

        setIsMoving(false);
      }}
      isActive={isActive}
      isMoving={isMoving}
      setActiveChatId={setActiveChatId}
      startRename={() => {
        setRenaming(true);
      }}
      unhide={async () => {
        setIsMoving(true);

        await unhideChat({ chatId: chat.id });

        setIsMoving(false);
      }}
    />
  );
};
